import { Link, router } from '@inertiajs/react'
import { useState } from 'react'

export default function Show({ offer, service_items }) {
  const [cartId, setCartId] = useState(null)
  const [adding, setAdding] = useState({})
  const [addedItems, setAddedItems] = useState({})

  const csrfToken = () =>
    document.querySelector('[name="csrf-token"]')?.content || ''

  const formatPrice = (cents) => {
    if (!cents) return 'Free'
    return `${(cents / 100).toFixed(2)} vuu`
  }

  const getOrCreateCart = async () => {
    if (cartId) return cartId
    const res = await fetch('/web_carts', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken() },
      body: JSON.stringify({
        offer_id: offer.id,
        provider: 'direct',
        category: offer.service_type || 'general'
      })
    })
    const data = await res.json()
    if (data.id) { setCartId(data.id); return data.id }
    throw new Error('Could not create cart')
  }

  const handleAddToCart = async (item) => {
    setAdding((prev) => ({ ...prev, [item.id]: true }))
    try {
      const cid = await getOrCreateCart()
      await fetch(`/web_carts/${cid}/add_item`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken() },
        body: JSON.stringify({
          item_id:         item.id.toString(),
          item_type:       'service_item',
          service_item_id: item.id,
          unit_price_cents: item.price_cents || 0,
          quantity:        1
        })
      })
      setAddedItems((prev) => ({ ...prev, [item.id]: true }))
    } catch (e) {
      alert('Could not add item. ' + e.message)
    } finally {
      setAdding((prev) => ({ ...prev, [item.id]: false }))
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Nav */}
        <div className="flex flex-wrap items-center justify-between gap-4 mb-8">
          <Link href="/" className="text-blue-600 hover:text-blue-800">← Back to Offers</Link>
          <div className="flex gap-3">
            {cartId && (
              <Link
                href={`/web_carts/${cartId}`}
                className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg"
              >
                View Cart ({Object.keys(addedItems).length})
              </Link>
            )}
            <Link
              href="/wallet"
              className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 px-4 rounded-lg"
            >
              Wallet
            </Link>
          </div>
        </div>

        {/* Offer header */}
        <div className="bg-white rounded-2xl shadow-md p-6 mb-6">
          <h1 className="text-3xl font-bold text-gray-900 mb-1">{offer.offer_name}</h1>
          <p className="text-gray-500">{offer.brand}</p>
          {offer.description && (
            <p className="mt-3 text-gray-700">{offer.description}</p>
          )}
          <div className="mt-3">
            <span className="inline-block bg-blue-100 text-blue-800 text-xs font-semibold px-3 py-1 rounded-full">
              Settlement: vuuCoin only
            </span>
          </div>
        </div>

        {/* Service items */}
        <h2 className="text-xl font-bold text-gray-900 mb-4">Available Items</h2>

        {service_items.length === 0 ? (
          <div className="bg-white rounded-xl shadow p-8 text-center text-gray-500">
            No menu items are currently available for this offer.
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {service_items.map((item) => (
              <div key={item.id} className="bg-white rounded-xl shadow p-5 flex flex-col justify-between">
                <div>
                  <div className="flex items-start justify-between">
                    <h3 className="text-lg font-semibold text-gray-900">{item.name}</h3>
                    <span className="text-blue-700 font-bold">{formatPrice(item.price_cents)}</span>
                  </div>
                  <p className="text-sm text-gray-500 mt-1 capitalize">{item.category}</p>
                </div>
                <button
                  onClick={() => handleAddToCart(item)}
                  disabled={adding[item.id]}
                  className={`mt-4 w-full py-2 px-4 rounded-lg font-semibold text-sm transition-colors ${
                    addedItems[item.id]
                      ? 'bg-green-100 text-green-800 border border-green-300'
                      : adding[item.id]
                      ? 'bg-blue-300 text-white cursor-wait'
                      : 'bg-blue-600 hover:bg-blue-700 text-white'
                  }`}
                >
                  {addedItems[item.id] ? '✓ Added' : adding[item.id] ? 'Adding…' : 'Add to Cart'}
                </button>
              </div>
            ))}
          </div>
        )}

        {/* Proceed to cart */}
        {cartId && (
          <div className="mt-8 text-center">
            <Link
              href={`/web_carts/${cartId}`}
              className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-xl text-lg"
            >
              View Cart & Checkout →
            </Link>
          </div>
        )}
      </div>
    </div>
  )
}
